import { Stack } from "@phosphor-icons/react";

export default function SelectionActionBar({ count, onClear, onMove }) {
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-black text-white shadow-2xl border-2 border-black flex items-center gap-4 pl-4 pr-2 py-2" data-testid="kanban-selection-bar">
      <div className="flex items-center gap-2">
        <span className="font-mono text-2xl font-black leading-none" data-testid="kanban-selection-count">{count}</span>
        <span className="text-[10px] font-bold uppercase tracking-widest">pedido{count > 1 ? "s" : ""} selecionado{count > 1 ? "s" : ""}</span>
      </div>
      <button
        type="button"
        onClick={onClear}
        className="text-xs font-bold uppercase tracking-widest border border-white/50 px-3 py-1.5 hover:bg-white hover:text-black transition-colors"
        data-testid="kanban-selection-clear"
      >
        Limpar
      </button>
      <button
        type="button"
        onClick={onMove}
        className="text-xs font-bold uppercase tracking-widest bg-white text-black px-4 py-1.5 hover:bg-yellow-400 transition-colors flex items-center gap-1.5"
        data-testid="kanban-selection-move"
      >
        <Stack size={14} weight="bold" /> Mover selecionados
      </button>
    </div>
  );
}
